

module.exports = __webpack_require__.stylable.create(
    "PendingGroupMeta593976620",
    {"classes":{"root":"PendingGroupMeta593976620__root","header":"PendingGroupMeta593976620__header","details":"PendingGroupMeta593976620__details"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "PendingGroupMeta593976620",
    null
);
